<template>
  <view class="parser-container">
    <view v-if="fields && fields.length > 0">
      <view v-for="(item, index) in fields" :key="index" class="form-item">
        <view class="label">
          <text v-if="item.__config__.required" class="required">*</text>
          {{ item.__config__.label }}
        </view>
        
        <view class="input-container">
          <!-- 文本输入 / 密码输入 -->
          <input 
            v-if="item.__config__.tag === 'el-input' && item.type !== 'textarea'"
            :type="item.type === 'password' ? 'password' : 'text'"
            v-model="formData[item.__vModel__]"
            :placeholder="item.placeholder"
            :disabled="disabled || item.disabled"
            class="uni-input"
          />
          
          <!-- 多行文本 -->
          <textarea 
            v-else-if="item.__config__.tag === 'el-input' && item.type === 'textarea'"
            v-model="formData[item.__vModel__]"
            :placeholder="item.placeholder"
            :disabled="disabled || item.disabled"
            class="uni-textarea"
            auto-height
          />
          
          <!-- 选择器 (模拟 el-select) -->
          <picker 
            v-else-if="item.__config__.tag === 'el-select'"
            @change="(e) => onPickerChange(e, item)"
            :value="getPickerIndex(item)"
            :range="item.__slot__.options"
            range-key="label"
            :disabled="disabled || item.disabled"
          >
            <view class="picker-value">
              {{ getPickerLabel(item) || item.placeholder || '请选择' }}
            </view>
          </picker>
          
          <!-- 开关 (模拟 el-switch) -->
          <switch 
            v-else-if="item.__config__.tag === 'el-switch'"
            :checked="formData[item.__vModel__]"
            @change="(e) => formData[item.__vModel__] = e.detail.value"
            :disabled="disabled || item.disabled"
            color="#26A69A"
          />
          
          <!-- 默认展示值 (只读模式) -->
          <view v-else class="readonly-value">
            {{ formData[item.__vModel__] || '暂无数据' }}
          </view>
        </view>
      </view>
    </view>
    <view v-else class="empty-tip">
      表单配置为空或解析失败
    </view>
  </view>
</template>

<script>
export default {
  name: 'FormParser',
  props: {
    formConf: {
      type: Object,
      default: () => ({})
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {},
      fields: []
    }
  },
  watch: {
    formConf: {
      handler(val) {
        if (val && val.fields) {
          this.fields = val.fields;
          this.initFormData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    initFormData() {
      const data = {};
      this.fields.forEach(field => {
        if (field.__vModel__) {
          data[field.__vModel__] = field.__config__.defaultValue;
        }
      });
      this.formData = Object.assign({}, data, this.formData);
    },
    
    // API: 设置表单数据
    setFormData(data) {
      if (!data) return;
      this.formData = Object.assign({}, this.formData, data);
    },
    
    // API: 获取表单数据
    getFormData() {
      return JSON.parse(JSON.stringify(this.formData));
    },
    
    // API: 校验表单
    validateForm() {
      let isValid = true;
      for (const field of this.fields) {
        if (field.__config__.required) {
          const value = this.formData[field.__vModel__];
          if (value === undefined || value === null || value === '') {
            isValid = false;
            break;
          }
        }
      }
      return isValid;
    },
    
    onPickerChange(e, item) {
      const index = e.detail.value;
      const option = item.__slot__.options[index];
      if (option) {
        this.formData[item.__vModel__] = option.value;
      }
    },
    
    getPickerIndex(item) {
      const value = this.formData[item.__vModel__];
      if (!item.__slot__ || !item.__slot__.options) return -1;
      return item.__slot__.options.findIndex(opt => opt.value === value);
    },
    
    getPickerLabel(item) {
      const value = this.formData[item.__vModel__];
      if (!item.__slot__ || !item.__slot__.options) return '';
      const option = item.__slot__.options.find(opt => opt.value === value);
      return option ? option.label : '';
    }
  }
}
</script>

<style scoped>
.parser-container {
  padding: 10rpx 0;
}

.form-item {
  margin-bottom: 24rpx;
}

.label {
  font-size: 28rpx;
  color: #333;
  margin-bottom: 12rpx;
  font-weight: 500;
}

.required {
  color: #ff4d4f;
  margin-right: 4rpx;
}

.input-container {
  background-color: #f9f9f9;
  border-radius: 8rpx;
  padding: 16rpx 20rpx;
}

.uni-input {
  height: 40rpx;
  font-size: 28rpx;
}

.uni-textarea {
  width: 100%;
  font-size: 28rpx;
  min-height: 80rpx;
}

.picker-value {
  font-size: 28rpx;
  color: #333;
}

.readonly-value {
  font-size: 28rpx;
  color: #666;
}

.empty-tip {
  text-align: center;
  color: #999;
  font-size: 24rpx;
  padding: 20rpx;
}
</style>
